<template>
  <div class="master-type-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row" v-if="item.id != null">
              <b-col cols="9" align-self="center">
                <b-form-group v-bind:label="$t('type_code')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.code">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('type_name')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.name">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('type_description')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.description">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('active')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                            v-model="item.is_active" v-bind:checked="item.is_active" :value="1" :uncheckedValue="0"/>
                </b-form-group>
              </b-col>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}">
                <b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button>
              </router-link>
              <b-button variant="success" v-on:click="updateItem" v-if="id != null"><i
                class="fa fa-save"></i> {{$t('update')}}
<!--                <b-button variant="success" v-on:click="updateItem" v-if="id != null && $auth.check(model + '.update')"><i-->
              </b-button>
<!--              <b-button variant="success" v-on:click="createItem" v-if="id == null && $auth.check(model + '.create')"><i-->
              <b-button variant="success" v-on:click="createItem" v-if="id == null"><i
                class="fa fa-save"></i> {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .switch {
    margin-bottom: 0px;
    margin-top: 7px;
    float: left;
    margin-right: 5px;
  }
</style>
<script>
  import cSwitch from '../../../../components/Switch'
  import {get, create, update} from '@/api/master_type'
  import {getMasterGroupList} from '@/api/master_group'
  import {getMasterAccountList} from '@/api/master_account'

  export default {
    name: 'MasterTypeForm',
    props: {
      id: {
        default: null
      }
    },
    components: {
      cSwitch
    },
    computed: {},
    data: function () {
      return {
        model: 'master_type',
        item: {
          id: null,
          group_id: '',
          account_id: '',
          code: '',
          name: '',
          description: '',
          is_active: 1
        },
        languages: Object.keys(this.$i18n.messages),
        groups: [],
        accounts: []
      }
    },
    methods: {
      /**
       * Get List Group
       */
      getListGroup() {
        this.$Progress.start()
        getMasterGroupList().then((response) => {
          for (let i in response.data.data) {
            this.groups.push({
              label: response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Get List Account
       */
      getListAccount() {
        this.$Progress.start()
        getMasterAccountList().then((response) => {
          for (let i in response.data.data) {
            this.accounts.push({
              label: response.data.data[i].name,
              value: response.data.data[i].id
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Get details of object
       */
      getDetail() {
        this.$Progress.start()
        let params = {
          id: this.id
        }
        get(params).then((response) => {
          this.item = response.data.data
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Update item info to server
       */
      updateItem() {
        this.$Progress.start()
        let param = Object.assign({}, this.item)
        param.group_id = this.item.group_id.value
        param.account_id = this.item.account_id.value
        update(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Create item info to server
       */
      createItem() {
        this.$Progress.start()
        let param = Object.assign({}, this.item)
        param.group_id = this.item.group_id.value
        param.account_id = this.item.account_id.value
        create(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      }
    },
    created: function () {
      this.getListGroup()
      this.getListAccount()
      if (this.id != null) {
        this.getDetail()
      } else {
        this.item.id = ''
      }
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/inventory/master_type/Form.vue